import { chartTimeToCoordinate } from './chartTimeProjection.js'

// Public primitive fallback: native setCrosshairPosition clamps unknown times
// to loaded bars. Draw projected coordinates without inserting fake data.
export class SyncedCrosshairPrimitive {
  constructor() {
    this.point = null
    this.view = { zOrder: () => 'top', renderer: () => ({ draw: target => target.useMediaCoordinateSpace(scope => this.draw(scope)) }) }
    this.label = {
      coordinate: () => this.y ?? 0,
      text: () => Number.isFinite(this.point?.price) ? this.series?.priceFormatter?.().format(this.point.price) || '' : '',
      textColor: () => '#FFFFFF',
      backColor: () => this.chart?.options().crosshair.horzLine.labelBackgroundColor || '#4c525e',
      visible: () => this.visible && this.y != null && this.chart?.options().crosshair.horzLine.visible !== false && this.chart?.options().crosshair.horzLine.labelVisible !== false,
      tickVisible: () => true,
    }
  }
  attached({ chart, series, requestUpdate }) { Object.assign(this, { chart, series, requestUpdate }) }
  detached() { this.chart = this.series = this.requestUpdate = this.point = null; this.visible = false }
  set(point, timeframe) { this.point = point; this.timeframe = timeframe; this.requestUpdate?.() }
  paneViews() { return [this.view] }
  priceAxisViews() { return [this.label] }
  updateAllViews() {
    this.visible = false; this.x = this.y = null
    if (!this.point || !this.chart || !this.series) return
    this.x = chartTimeToCoordinate(this.chart, this.series, this.point.time, this.timeframe)
    const height = this.series.getPane?.().getHeight()
    const y = Number.isFinite(this.point.price) ? this.series.priceToCoordinate(this.point.price) : null
    this.y = y != null && (height == null || (y >= 0 && y <= height)) ? y : null
    this.visible = this.x != null && this.x >= 0 && this.x <= this.chart.timeScale().width()
  }
  draw({ context: ctx, mediaSize: { width, height } }) {
    this.updateAllViews()
    if (!this.visible) return
    const options = this.chart.options().crosshair
    const line = (style, x1, y1, x2, y2) => {
      if (style.visible === false) return
      ctx.save(); ctx.strokeStyle = style.color; ctx.lineWidth = style.width || 1
      const unit = style.width || 1
      ctx.setLineDash(({ 1: [unit, unit], 2: [2 * unit, 2 * unit], 3: [6 * unit, 6 * unit], 4: [unit, 4 * unit] })[style.style] || [])
      ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke(); ctx.restore()
    }
    line(options.vertLine, this.x, 0, this.x, height)
    if (this.y != null) line(options.horzLine, 0, this.y, width, this.y)
  }
}
